import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ large, className, copy }) => (
  <>
    <div className={`spinner ${large ? 'spinner-lg' : ''} ${className || ''}`} data-testid='spinner' />
    {copy && <div className={`spinner__text u-full-width ${large ? 'spinner-lg' : ''}`}>{copy}</div>}
  </>
);

Spinner.defaultProps = {
  large: false,
  className: null,
  copy: null
};

Spinner.propTypes = {
  large: PropTypes.bool,
  className: PropTypes.string,
  copy: PropTypes.string
};

export default Spinner;
